const o = () => typeof navigator == "object" && navigator.userAgent.length > 0 && navigator.userAgent.includes("jsdom"), e = () => typeof process == "object" && process.versions !== void 0 && process.versions.node !== void 0, s = () => typeof window == "object" && typeof document == "object" && document.nodeType === 9;
export {
  s as isBrowser,
  o as isJsDom,
  e as isNode
};
